import React from 'react'

function CategoriaLoading() {

    return (
      <div style={{top:'110px',position:'absolute'}}>
        <span> Cargando las categorías... </span>
      </div>
    )

}

export { CategoriaLoading };
